/* 商品接口 */
import http from '@/utils/http'

const api = {
  getVipGoodsList: '/api/getVipGoodsList',
  getGoodsInfo: '/api/getGoodInfo'
}

/**
 * 获取vip商品列表
 * @export
 * @returns
 */
export function getVipGoodsList() {
  return http.get(api.getVipGoodsList)
}

/**
 * 根据商品id获取商品信息
 * @export
 * @param {string|number} goodsId 商品id
 * @param {string} [token] 用户token
 * @returns
 */
export function getGoodsInfo(goodsId, token = '') {
  return http.get(`${api.getGoodsInfo}?good_id=${goodsId}&token=${token}`)
}
